<script setup lang="ts">
import { trackResponsibleView } from '~/tracking/responsibleGamingEvents.js'
import HeroSection from '~/components/pages/responsible-gaming/HeroSection.vue'
import WhySection from '~/components/pages/responsible-gaming/WhySection.vue'
import PillarsSection from '~/components/pages/responsible-gaming/PillarsSection.vue'
import ControlSection from '~/components/pages/responsible-gaming/ControlSection.vue'
import WarningSection from '~/components/pages/responsible-gaming/WarningSection.vue'
import HelpSection from '~/components/pages/responsible-gaming/HelpSection.vue'
import CommitmentSection from '~/components/pages/responsible-gaming/CommitmentSection.vue'

definePageMeta({
	layout: 'legal',
})

const sendEventView = () => {
	trackResponsibleView()
}

onMounted(() => {
	sendEventView()
})
</script>

<!-- Responsible Gaming Page -->
<template>
	<main class="bg-white">
		<!-- Hero Section -->
		<HeroSection />

		<!-- Why This Page Section -->
		<WhySection />

		<!-- Pillars Section -->
		<PillarsSection />

		<!-- Control Section -->
		<ControlSection />

		<!-- Warning Signs Section -->
		<WarningSection />

		<!-- Help Section -->
		<HelpSection />

		<!-- Commitment Section -->
		<CommitmentSection />
	</main>
</template>
